module.exports = __webpack_public_path__ + "static/media/0.dd61e01f.mp3";